import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import find from 'lodash/find'
import styled from 'styled-components'
import { DataInput } from './input-col'
import { InfoData } from './info-col'
import * as CONSTANTS from '../../constants'
import { FONTS } from '../../../../constants'
import ChooseProject from '../../../../static/images/timesheet-choose-project.svg'

const filterTimesheetByProjects = (data, timesheets, searchTimesheet) => {
  const users = get(timesheets, 'users', [])
  const search = searchTimesheet.toLowerCase()
  return data.filter((element) => {
    const user = find(users, { _id: element.user_id })
    const emp_code = get(user, 'emp_code', '')
    const firstname = get(user, 'first_name', '').toLowerCase()
    const lastname = get(user, 'last_name', '').toLowerCase()
    const nickname = get(user, 'nick_name', '').toLowerCase()
    return emp_code.includes(search)
    || firstname.includes(search)
    || lastname.includes(search)
    || nickname.includes(search)
  })
}

export const DataRow = (props) => {
  const { searchTimesheet, timesheets } = props
  let timesheetProjects = get(props, 'timesheetByProjects.timesheets', [])
  const holidaysByProject = get(props, 'timesheetByProjects.holidays', [])
  timesheetProjects = filterTimesheetByProjects(timesheetProjects, timesheets, searchTimesheet)

  switch (get(props, 'filterButton')) {
    case 2:
      timesheetProjects = timesheetProjects.filter(
        (element) => element.status === CONSTANTS.NONSUBMIT)
      break
    case 3:
      timesheetProjects = timesheetProjects.filter(
        (element) => element.status === CONSTANTS.PENDING)
      break
    case 4:
      timesheetProjects = timesheetProjects.filter(
        (element) => element.status === CONSTANTS.APPROVED)
      break
    case 5:
      timesheetProjects = timesheetProjects.filter(
        (element) => element.status === CONSTANTS.REJECTED)
      break
    default:
      break
  }

  const selectedIDProjects = get(props, 'selectedIDProjects')
  if (!selectedIDProjects) {
    return (
      <IconWrapper>
        <Icon src={ ChooseProject } alt='notAvailable' />
        <span style={ { fontFamily: FONTS.GOTHAM_MEDIUM, fontSize: FONTS.TITLE_SIZE } }>
          Choose project to display
        </span>
        <span style={ { fontFamily: FONTS.GOTHAM, fontSize: FONTS.SMALL_SIZE } }>
          { `Select the project from the top dropdown button to display TImesheet by Projects.`}
        </span>
      </IconWrapper>
    )
  }
  return (
    <Wrapper>
      {
        timesheetProjects.map((timesheet) => {
          return (
            <InfoRow>
              <Container>
                <InfoData
                  timesheetProject={ timesheet }
                  { ...props }
                />
                <DataInput
                  timesheetProject={ timesheet }
                  holidaysByProject={ holidaysByProject }
                  { ...props }
                />
              </Container>
            </InfoRow>
          )
        })
      }
    </Wrapper>
  )
}

DataRow.propTypes = {
  timesheets: PropTypes.object,
  searchTimesheet: PropTypes.string,
}
DataRow.defaultProps = {
  timesheets: {},
  searchTimesheet: '',
}

const Wrapper = styled.div`
  background-color: #FFFFFF;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
`
const Container = styled.div`
  height: 50px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #cccccc;
`
const IconWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 50px 50px 50px;
`
const Icon = styled.img`
  height: 200px;
  width: 200px;
  cursor: pointer;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-by-project/data-row.js